import React, { Fragment } from "react";
import { useWeWorkAnalytics } from "./wework_analytics";
import { OfferingDetailsDailyAccess } from "../template_offering_details_daily_access";
import {
  faqsEN as dailyFaqsEN,
  generalInfoEN as dailyGeneralInfoEN,
  descriptionEN as dailyDescriptionEN,
  faqsHE as dailyFaqsHE,
  generalInfoHE as dailyGeneralInfoHE,
  descriptionHE as dailyDescriptionHE,
} from "./offering_wework_daypass";
import {
  faqsEN as multiFaqsEN,
  generalInfoEN as multiGeneralInfoEN,
  descriptionEN as multiDescriptionEN,
  faqsHE as multiFaqsHE,
  generalInfoHE as multiGeneralInfoHE,
  descriptionHE as multiDescriptionHE,
} from "./offering_wework_multipass";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { useWeWorkPartnerConfig } from "./wework_partner_config";
import { lazyWithRetry } from "../../core/lazy_with_retry";

const Theme = lazyWithRetry(() => import("./wework_theme"));

export function OfferingWeWorkDailyAccess() {
  const { locale } = useI18n();
  useWeWorkAnalytics();
  const partnerConfig = useWeWorkPartnerConfig();
  const data =
    locale.baseLanguageTag === "he"
      ? {
          multiDescription: multiDescriptionHE,
          multiFaqs: multiFaqsHE,
          multiGeneralInfo: multiGeneralInfoHE,
          dailyDescription: dailyDescriptionHE,
          dailyFaqs: dailyFaqsHE,
          dailyGeneralInfo: dailyGeneralInfoHE,
        }
      : {
          multiDescription: multiDescriptionEN,
          multiFaqs: multiFaqsEN,
          multiGeneralInfo: multiGeneralInfoEN,
          dailyDescription: dailyDescriptionEN,
          dailyFaqs: dailyFaqsEN,
          dailyGeneralInfo: dailyGeneralInfoEN,
        };

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDailyAccess
        showAddress
        showDirections
        limitQuantityPicker={4}
        firstDayOfWeek={0}
        partnerConfig={partnerConfig}
        useLegacyImages={true}
        data={data}
      />
    </Fragment>
  );
}
